(function() {
	'use strict';

	angular
		.module('pwc.model')
		.service('Wine', Wine);

	Wine.$inject = ['$window', 'BaseModel', 'Slug', 'lodash', 'WinePurchase', 'WineSale', 'WineDrink', 'WineGift', 'WineLoss', '$log'];

	function Wine($window, BaseModel, Slug, lodash, WinePurchase, WineSale, WineDrink, WineGift, WineLoss, $log) {

		var factories = {
			"Purchase": WinePurchase,
			"Sale": WineSale,
			"Drink": WineDrink,
			"Gift": WineGift,
			"Loss": WineLoss
		};

		// Entity Defaults
		var defaults = $window.stampit().state({
			"created": $window.moment().toISOString(),
			"updated" : $window.moment().toISOString(),
			"bottleSize": {
				"name": "750 ml (standard)"
			},
			"producer": {
				"name": null
			},
			"varietal": {
				"name": null
			},
			"distinction": {
				"name": null
			},
			"vineyard": {
				"name": null
			},
			"maker": {
				"name": null
			},
			"cellar": {
				"qty": 0,
				"location": null,
				"starred": false,
				"wished": false,
				"tasted": false,
				"ordered": false,
				"value": 0.00,
				"totalValue": 0.00,
				"history": []
			},
			"notes": null,
			"docs": [],
			"grapes": [],
			"region": {
				"name": null
			}
		});

		// attach methods to entity
		var WineFactory = $window.stampit().enclose(function () {

			this.generateId = function(){
				var parts = [
					lodash.get(this, 'producer.name'),
					lodash.get(this, 'varietal.name'),
					lodash.get(this, 'name'),
					lodash.get(this, 'region.name'),
					lodash.get(this, 'vineyard.name'),
					lodash.get(this, 'vintage')
				];

				lodash.forEach(parts, function(item, k){
					if (lodash.isNull(item)){
						delete parts[k];
					}
				});

				return Slug.slugify(parts.join(' '));
			};

			this.getFullName = function(){
				return [lodash.get(this, 'producer.name'), this.name, this.vintage].join(" ").trim();
			};

			this.updateTotal = function(){
				var qty = lodash.parseInt(this.cellar.qty);

				if (this.cellar.value > 0 && qty > 0){
					this.cellar.totalValue = parseFloat(qty * this.cellar.value).toFixed(2);
				} else {
					this.cellar.totalValue = 0;
				}

				if (this.cellar.qty === 0) {
					// @TODO fix this - causes memory leak
					//$rootScope.$emit('bottleCountIsZero', {wine: this});
				}
			};

			// if something may have changed on transaction items, we need to recalculate qty
			this.updateQty = function(){
				if (this.hasHistory()){
					var history = this.getCombinedHistory();

					var qty = 0;

					lodash.forEach(history, function(transaction){
						if (transaction.isAddition()){
							qty = qty + lodash.parseInt(transaction.qty);
							return true;
						}
						if (transaction.isSubtraction()){
							qty = qty - lodash.parseInt(transaction.qty);
							return true;
						}
					});

					this.cellar.qty = qty;

				} else {
					this.cellar.qty = 0;
				}
			};

			// this doesn't seem to be run
			// @todo this.cellar.ordered doesn't seem to be accurate, always false.
			this.updateCellar = function(){
				this.updateQty();
				this.updateTotal();
				// flag ordered if necessary
				var onOrderQty = this.getOnOrderQty();

				if (onOrderQty > 0){
					this.cellar.ordered = true;
				} else {
					this.cellar.ordered = false;
				}

				if (this.cellar.qty > 0){
					this.cellar.tasted = false;
					this.cellar.wished = false;
				}

				if (this.cellar.qty === 0){
					this.cellar.location = null;
				}
			};

			this.hasHistory = function(){
				var history = lodash.get(this, 'cellar.history');
				return history && history.length !== 0 ? true : false;
			};

			this.getCombinedHistory = function(){

				if (! this.hasHistory()){
					return null;
				}

				var all = lodash.map(this.cellar.history, function(record){
					var type = lodash.capitalize(record['type']);

					var item = factories[type](record);

					if (item.note)
					{
						// move to notes
						item.notes = item.note;
						delete item.note;
					}

					return item;
				});

				return lodash.sortByOrder(all, 'date');
			};

			this.getFullAppellation = function(){
				if (lodash.isEmpty(this.region.name)){
					return null;
				}
				var pieces = [this.region.name];

				if (this.region['parent']){
					pieces.push(this.region['parent']['name']);
				}

                if (this.region['country']){
                    pieces.push(this.region.country);
                }

				return pieces.join(' > ');
			};

			this.getRegionSummary = function() {
				var region = '';

				if (this.region) {
					if (this.region.parent && this.region.parent.name) {
						region = this.region.parent.name;
					} else if (this.region.name) {
						region = this.region.name;
					}
				}

				return region;
			};

			/**
			 * If you have a region and a parent then the sub region is the region.name?
			 *
			 * @todo needs testing on more db's
			 *
			 * Logic:
if(! lodash.empty(region.parent) {
	// is subregion
}
			 *
			 * Examples
			 *
			 * Known SubRegion:
			 http://localhost:3000/#/wines/edit/alexander-valley-vineyards-cabernet-sauvignon-cabernet-sauvignon-alexander-valley-2013
 "region": {
	"name": "Alexander Valley",
	"country": "United States",
	"legacyId": "2006",
	"parent": {
		"name": "California (Sonoma)",
		"legacyId": "3139"
	}
},

			 * Unknown SubRegion:
			 http://localhost:3000/#/wines/edit/philippe-prie-champagne-blend-champagne-champagne-0-19635
 "region": {
	"name": "Champagne",
	"country": "France",
	"legacyId": "3021"
},
			 *
			 * @returns String
             */
			this.getSubRegionSummary = function() {
				return (this.region && this.region.parent) ? this.region.name : '';
			};

			this.getOnOrderQty = function(){

				if (lodash.isEmpty(this.cellar.history)){
					return 0;
				}

				var purchasesOnOrder = this.getPurchasesOnOrder();

				return lodash.sum(lodash.pluck(purchasesOnOrder, 'qty'));
			};

			this.setThumbnail = function(thumbnail){
				this.thumbnail = thumbnail;
			};

			this.isFavorite = function(){
				return this.cellar.starred;
			};

			// this is really the acquisition history, not necessarily only purchase
			this.getAcquisitionHistory = function(){

				if (! this.hasHistory()){ return null; }

				var all = [];

				lodash.forEach(lodash.get(this, 'cellar.history'), function(record){
					var type = record['type'];

					if (type === 'purchase'){
						all.push(factories[lodash.capitalize(type)](record));
					}
				});

				return lodash.sortByOrder(all, 'date');
			};

			this.getHistoryByCategory = function(category){
				var acquisitionHistory = this.getAcquisitionHistory();

				return lodash.filter(acquisitionHistory, function(item){
					return (item.category && item.category.toLowerCase() === category.toLowerCase());
				});
			};

			this.getPurchaseHistory = function(){
				var acquisitionHistory = this.getAcquisitionHistory();

				return lodash.filter(acquisitionHistory, function(item){
					// wine doesn't need to have a category to count as a purchase history!
					if (item.category && item.category.toLowerCase() === 'gift') {
						return false;
					}
					return true;
				});
			};

			this.getPurchasesOnOrder = function(){
				return lodash.where(this.cellar.history, {"type": "purchase", "status": "On Order" });
			};

			this.getDrinkHistory = function(){
				if (! this.hasHistory()){ return null; }

				var all = [];

				lodash.forEach(lodash.get(this, 'cellar.history'), function(record){
					var type = record['type'];

					if (type === 'drink'){
						all.push(factories[lodash.capitalize(type)](record));
					}
				});

				return lodash.sortByOrder(all, 'date');
			};

			this.getSaleHistory = function(){
				if (! this.hasHistory()){ return null; }

				var all = [];

				lodash.forEach(lodash.get(this, 'cellar.history'), function(record){
					var type = record['type'];

					if (type === 'sale'){
						all.push(factories[lodash.capitalize(type)](record));
					}
				});

				return lodash.sortByOrder(all, 'date');
			};

            this.getGiftHistory = function(){
                if (! this.hasHistory()){ return null; }

                var all = [];

                lodash.forEach(lodash.get(this, 'cellar.history'), function(record){
                    var type = record['type'];

                    if (type === 'gift'){
                        all.push(factories[lodash.capitalize(type)](record));
                    }
                });

                return lodash.sortByOrder(all, 'date');
            };

			this.avgPurchasePrice = function(){

				var purchaseHistory = this.getPurchaseHistory();

				if (lodash.isEmpty(purchaseHistory)){ return 0; }

				var paidPrices = [];

				lodash.forEach(purchaseHistory, function(item){
					var price = parseFloat(item.price);

					if (price > 0){
						// if you buy 10 bottles at $1, that should bring the price down quite a bit more than just 1 bottle at $1
						for(var i = 0; i < item.qty; i++) {
							paidPrices.push(price);
						}
					}
				});

				if (paidPrices.length === 0){
					return 0;
				}

                return $window.numeral(lodash.sum(paidPrices) / paidPrices.length).format('0.00');
			};

			this.getMaturity = function(){
				var currentYear = lodash.parseInt(window.moment().format('YYYY'));
				var after = lodash.get(this, 'cellar.aging.after', null);
				var by = lodash.get(this, 'cellar.aging.by', null);

				if (! after && ! by){
					return 'Uncertain';
				}

				if (currentYear > by){
					// past it's prime, you have the full year of the drink by
					return 'Late';
				}

				if (currentYear < after){
					// don't drink yet! you can start drinking the wine in the after year
					return 'Early';
				}

				after = lodash.parseInt(after);

				by = lodash.parseInt(by);

				/**
				 * We are going to chunk the after and by dates into thirds.
				 */

				var spread = by - after + 1;

				var range = lodash.range(after, by + 1);

				// Determine chunk number
				var chunk = Math.floor(spread / 3);

				var chunked = lodash.chunk(range, chunk);

				var groupIdx = null;

				// see what chunk the current year falls in
				lodash.forEach(chunked, function(v, k){
					if(lodash.contains(v, currentYear)){
						groupIdx = k;
					}
				});

				var maturity = null;

				switch (groupIdx){
					case 0:
						maturity = 'Young';
					break;

					case 1:
						maturity = 'Mature';
					break;

					case 2:
						maturity = 'Old';
					break;

					default:
						// we chunk into thirds but there could be a 4th group if it doesn't divided equally
						maturity = 'Old';
					break;
				}

				return maturity;
			};

			this.updateMaturity = function(){
				var maturity = this.getMaturity();

				if (maturity && maturity !== lodash.get(this, 'cellar.aging.maturity')){
					lodash.set(this, 'cellar.aging.maturity', maturity);
					return true;
				}

				return false;
			};

			this.hasIndustryRating = function(){
				var key = lodash.findKey(lodash.get(this, 'rating.other'), function(o) { return lodash.isNotEmptyOrNull(o); });
				return lodash.isNotEmptyOrNull(key) ? true : false;
			};

			/**
			 * some this.cellar.value were NaN (Eg. an empty string "")
			 *
			 * This fixes it by defaulting to no value / 0.00
			 *
			 * @returns Float
             */
			this.getBottleValue = function() {
				var valueFloat = parseFloat(this.cellar.value);
				return (lodash.isFinite(valueFloat)) ? valueFloat : 0.00;
			};

			/**
			 * getRelativeGainPercent
			 *
			 * returns false if infinite, true if no wines in cellar, return 0 if no change, otherwise value / purchasePrice - 1.0 (Float)
			 */
			this.getRelativeGainPercent = function(purchasePrice) {
				var value = this.getBottleValue();

				// gain/loss not applicable b/c there is no stock
				if (this.cellar.qty === 0) {
					return true;
				}

				// if none in cellar we don't care, return 0, no change.
				// Or
				// JS math isn't what we want (NaN) so let's catch this specific use case.
				if (value === 0 && purchasePrice === 0) {
					return 0;
				}

				var amount = value / purchasePrice - 1.0;


				if (! lodash.isFinite(amount)) {
					amount = false;
				}

				return amount;
			};

			this.getRelativeGainPercentFormatted = function(purchasePrice) {
				var amount = this.getRelativeGainPercent(purchasePrice);
				var formattedAmount;

				switch (amount) {
					// not applicable / no stock
					case true:
						formattedAmount = '-';
						break;

					// not finite
					case false:
						formattedAmount = '&infin;';
						break;

					// an actual percentage! (includes 0)
					default:
						formattedAmount = $window.numeral(amount).format('0[.]0%');
				}

				return formattedAmount;
			};

			/**
			 * returns nochange, loss or gain dependent on wine's Gain / Loss amount
			 *
			 * @returns {string}
             */
			this.getValueGainType = function(purchasePrice) {
				var valueGain = this.getRelativeGainPercent(purchasePrice);
				var valueGainType = '';

				// no bottles in cellar or no change
				if (valueGain === 0 || valueGain === true) {
					valueGainType = 'nochange';
				} else if (valueGain < 0) {
					valueGainType = 'loss';
				} else {
					// includes infinite
					valueGainType = 'gain';
				}
				return valueGainType;
			};

			/**
			 * helper to build CSS class for reports based on value Gain / Loss amount
			 * @returns {string}
             */
			this.getValueGainClass = function(purchasePrice) {
				return 'report-value-' + this.getValueGainType(purchasePrice);
			};

			/**
			 *
			 * @param momentDate
             * @returns {number}
             */
			this.getValueAtDate = function(momentDate) {
				var totalValue = 0;
				var value = this.cellar.value;

				if (value > 0) {
					var qty = this.getCellarQtyAtDate(momentDate);
					totalValue = value * qty;
				}

				return totalValue;
			};

			this.getCellarQtyAtDate = function(momentDate) {
				var qty = 0;

				lodash.forEach(this.getCombinedHistory(), function(acquisition) {
					var acquisitionMoment = moment(acquisition.date);

					if (acquisitionMoment <= momentDate) {
						// some acquisitions are addition (purchase), some are subtraction (drink, gift, sale loss)
						if (acquisition.isAddition()) {
							qty += acquisition.qty;
						} else {
							qty -= acquisition.qty;
						}
					}
				});

				return qty;
			};

			this.upsertCombinedHistoryItem = function(item, combinedHistoryIndex){

				if (lodash.isEmptyOrNull(combinedHistoryIndex)){
					// this is a creation
					$log.debug('Adding new history item', item);

					this.cellar.history.push(item);

					this.updateCellar();

				} else {

					var combinedHistory = this.getCombinedHistory();

					var transaction = lodash.first(lodash.at(combinedHistory, combinedHistoryIndex));

					if (transaction){
						$log.debug('Found transaction to upsert', transaction);

						var history = [];

						lodash.set(combinedHistory, combinedHistoryIndex, item);

						lodash.forEach(combinedHistory, function (o, key){
							history.push(o.getData());
						});

						this.cellar.history = history;

						$log.debug('New wine history', this.cellar.history);

						this.updateCellar();

						return true;
					}
				}

				return false;

			};

			this.addDoc = function(doc){
				if (! lodash.isArray(this.docs)){
					this.docs = [];
				}

				if (doc && ! lodash.includes(this.docs, doc)){
					this.docs.push(doc);
					return true;
				}

				return false;
			};

			this.grapeSummary = function(){
				var grapes = this.grapes;

				if (grapes && grapes.length > 0){
					return lodash.map(grapes, function(item){
						return item.pct ? item.name + ' (' + item.pct + '%)' : item.name;
					}).join(', ');
				}

				return null;
			};

			return $window.stampit.mixIn(this, BaseModel);
		});

		return function (properties){
			var entity = $window.stampit.compose(defaults, WineFactory).create(properties);
			// maturity is dynamic, attempt to update
			entity.updateMaturity();
			return entity;
		};

	}

})();
